export default "__VITE_ASSET__KycoaeVa__"